<template>
  <ModalDialog
    ref="dialog"
    title="External Items Updated"
    icon="fa-external-link-alt"
    sizeClass='modal-med'
    :submitting="submitting"
    submitTitle="Update"
    :submitDisabled="!hasUpdateOptionSelected"
    @closed="onClosed"
    @submitted="onSubmitted">

    <div>
      <NotificationBar type="warning">
        <NotificationBarTitle>External Items Update</NotificationBarTitle>
        There are order items with an external flag and/or the order has linked purchase orders
      </NotificationBar>

      Editing the order items may cause discrepencies with current purchase orders.<br />
      Select below how to proceed with the order item update
      <br /><br />
      <div class="ml-4">
        <FormOptionGroup>
          <FormOption label="Reset Purchase Orders" name="orderItemExternalUpdateType" :setting="OrderItemExternalUpdateTypes.resetExternalSetup" v-model="orderItemExternalUpdateType" inline="false" /><br />
          <div class="ml-4">
            Automatically cancels any existing purchase orders and moves the order back to external setup.<br />
            Use this option if any items with the external flag were modified. Or new external items were added.<br /><br />
            <strong>Warning:</strong><br />
            <ul>
              <li>All existing purchase orders for this order will be <strong>cancelled</strong> and a cancellation email will need to sent to the supplier</li>
              <li>New purchase orders will need to be created for any external items to continue the order</li>
            </ul>
          </div>
          <FormHorizontalRule />
          <FormOption label="Do Not Modify Purchase Orders" name="orderItemExternalUpdateType" :setting="OrderItemExternalUpdateTypes.ignoreExternalSetup" v-model="orderItemExternalUpdateType" inline="false" /><br />
          <div class="ml-4">
            Updates the order items without modifying the existing purchase orders.<br />
            Use this option if no items with the external flag were modified, or minor updates were made.<br /><br />
            <strong>Warning:</strong><br />
            <ul>
              <li>If external items were modified, these changes will not be reflected in the linked purchase orders</li>
              <li>This may cause issues when linked purchase orders are completed and they do not match the external order items</li>
            </ul>
          </div>
        </FormOptionGroup>
      </div>        
    </div>
  </ModalDialog>
</template>

<script>
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import { OrderItemExternalUpdateTypes } from '@/store/types'

export default {
  name: 'OrderExternalItemUpdateDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    submitPromise: Function
  },
  data() {
    return {
      submitting: false,
      orderItemExternalUpdateType: ''      
    }
  },
  created() {
    this.OrderItemExternalUpdateTypes = OrderItemExternalUpdateTypes
  },
  mounted() {
  },
  computed: {
    hasUpdateOptionSelected() {
      return this.orderItemExternalUpdateType != ''
    }
  },
  methods: {
    show(params) {
      return modalDialog.methods.show.call(this, params)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() { 
      this.modalClosed(this.orderItemExternalUpdateType)
      this.hide()
    }
  }
}
</script>